export const isEmpty = (value?: unknown): boolean => {
  if (!value) return true;
  if (Array.isArray(value)) return value.length === 0;
  if (value == null) return true;
  if (typeof value === 'string') return value.length > 0;

  return Object.keys(value).length === 0;
};

export const convertEmptyStringToUndefinedFromObject = (data: Record<string, any>): Record<string, any> => {
  const result: Record<string, any> = {};

  for (const key in data) {
    result[key] = data[key] === '' ? undefined : data[key];
  }

  return result;
};
